import { ChangeDetectionStrategy, Component, HostBinding, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'mc-snack-bar-warning',
  templateUrl: './snack-bar-warning.component.html',
  styleUrls: ['./snack-bar-warning.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SnackBarWarningComponent {
  @HostBinding('class') class = 'mc-snack-bar';

  showCloseButton: boolean = false;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public message: string,
    private snackBarRef: MatSnackBarRef<SnackBarWarningComponent>
  ) {
    this.showCloseButton = typeof this.snackBarRef.containerInstance.snackBarConfig.duration !== 'number' || this.snackBarRef.containerInstance.snackBarConfig.duration === 0;
    this.snackBarRef.containerInstance.snackBarConfig.panelClass = ['mc-snack-bar', 'mc-snack-bar-panel', 'mc-caution'];
  }

  close() {
    this.snackBarRef.dismiss();
  }
}
